import { Pagination, QueryParams } from "@/models/query-params.model";
import { Theme, ThemePayload } from "@/models/theme.model";
import { api } from "@/services/api-config/setup";

export class ThemeRest {
  getAllThemes(params: Partial<QueryParams>): Promise<Pagination<Theme>> {
    const url: string = `/themes`;
    return api()
      .get(url, { params })
      .then((response) => response.data);
  }

  static addTheme(data: FormData): Promise<ThemePayload> {
    const url: string = `/themes`;
    return api()
      .post(url, data)
      .then((response) => response.data);
  }

  static updateTheme(
    themeId: string,
    data: ThemePayload
  ): Promise<ThemePayload> {
    const url: string = `/themes/${themeId}`;
    return api()
      .put(url, data)
      .then((response) => response.data);
  }
}
